import request from './axios';

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
export function submitContact(data) {
  return request({
    url: '/webapi/contact/submit',
    method: 'post',
    data
  });
}

/**
 * 获取公司联系信息
 * @returns {Promise<Object>} 返回公司联系信息
 */
export function getContactInfo() {
  return request({
    url: '/webapi/contact/info',
    method: 'get'
  });
}

export default {
  submitContact,
  getContactInfo
}; 